import ContextConnectButton from '@/components/ContextCard/ContextConnectButton'
import { Button } from '@mui/material'
import { Clock16Regular } from '@/components/Icon'
import { cronContextLabel } from '@/features/chat/phase1/cronContextLabel'
import styles from '@/components/ContextCard/contextCardMedia.module.scss'
import actionStyles from '@/components/ContextCard/contextCardActions.module.scss'

export default function AutomationCardInner({ block, status, error, pending, act, note, onOpen }) {
  return (
    <div className={styles.media}>
      <span className={`${styles.glyph} ${styles.clock}`} aria-hidden>
        <Clock16Regular fontSize={20} />
      </span>
      <div className={styles.copy}>
        <div className={styles.meta}>{cronContextLabel(block.cron, block.timezone)}</div>
        <div className={styles.title}>{block.title || 'Scheduled task'}</div>
        {note ? <div className={styles.meta}>{note}</div> : null}
        {error ? <div className={styles.meta}>{error}</div> : null}
        {status === 'draft' ? (
          <div className={actionStyles.actions}>
            <ContextConnectButton hideIcon disabled={pending} onClick={() => act('start')}>
              Start schedule
            </ContextConnectButton>
            <Button size="small" disabled={pending} onClick={() => act('discard')}>
              Discard
            </Button>
          </div>
        ) : null}
      </div>
      {onOpen ? (
        <ContextConnectButton hideIcon className={styles.open} onClick={onOpen}>
          Open
        </ContextConnectButton>
      ) : null}
    </div>
  )
}
